import listActions from 'src/modules/objetivo/list/objetivoListActions';
import ObjetivoService from 'src/modules/objetivo/objetivoService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'OBJETIVO_DESTROY';

const objetivoDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: objetivoDestroyActions.DESTROY_STARTED,
      });

      await ObjetivoService.destroyAll([id]);

      dispatch({
        type: objetivoDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.objetivo.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/objetivo');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: objetivoDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: objetivoDestroyActions.DESTROY_ALL_STARTED,
      });

      await ObjetivoService.destroyAll(ids);

      dispatch({
        type: objetivoDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.objetivo.destroyAll.success'),
      );

      getHistory().push('/objetivo');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: objetivoDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default objetivoDestroyActions;
